import { useState } from "react";
import p2 from "~/assets/business/p2@3x.png";
import mbp2 from "~/assets/business/mb-p2@3x.png";
import p3 from "~/assets/business/p3@3x.png";
import p4 from "~/assets/business/p4@3x.png";
import p5 from "~/assets/business/p5@3x.png";
import p6 from "~/assets/business/p6@3x.png";
import p7 from "~/assets/business/p7@3x.png";
import p8 from "~/assets/business/p8@3x.png";
import p9 from "~/assets/business/p9@3x.png";
import p11 from "~/assets/business/p11@3x.png";
import p12 from "~/assets/business/p12@3x.png";
import p13 from "~/assets/business/p13@3x.png";
import p16 from "~/assets/business/p16@3x.png";
import p17 from "~/assets/business/p17@3x.png";
import p18 from "~/assets/business/p18@3x.png";
import p19 from "~/assets/business/p19@3x.png";
import p20 from "~/assets/business/p20@3x.png";
import p21 from "~/assets/business/p21@3x.png";

import SiteLayout from "components/layout/SiteLayout";

import { Collapse } from "antd";

const Page = () => {
  const pageScrollBottom = () => {
    window.scroll({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <SiteLayout pageTitle="职场英语1对1陪学训练营" largeContainer="true">
      <div className="bn-wrapper">
        <div className="block1">
          <div className="content">
            <div className="left">
              <div className="text">职场英语</div>
              <div className="text">1对1陪学训练营</div>
            </div>
            <div className="learn-btn" onClick={pageScrollBottom}>
              我要学习&gt;
            </div>
            <img src={mbp2.src} className="mbp2" />
            <img src={p2.src} className="p2" />
          </div>
        </div>
        <div className="block2">
          <div className="content">
            <div className="title-w">
              <div className="title title-mb">
                <img className="circle-big" src={p18.src} />
                全面诊断科学规划
              </div>
              <div className="title title-mb">
                个性化教学，专属学习方案
                <img className="circle-small" src={p19.src} />
              </div>
              <div className="title title-pc">
                <img className="circle-big" src={p18.src} />
                全面诊断科学规划，个性化教学，专属学习方案
                <img className="circle-small" src={p19.src} />
              </div>
              <div className="line"></div>
            </div>
            <div className="sub-title-mb">
              因材施教 按需备课 一对一课程给您规划
            </div>
            <div className="text-content-wrapper">
              <div>
                <div className="sub-title-pc">
                  因材施教 按需备课 一对一课程给您规划
                </div>
                <div className="text-content">
                  课程内容涵盖语法、词汇及职场听说读写精讲；根据你的英语基础、学习目标、每周可投入时间科学规划学习方案，1对1海外华人老师全程陪学。1v1专属学习方案，不论是发音差、语法弱、场景交流紧张，亦或是面试、邮件、职场还是生活场景，均可满足。
                </div>
              </div>
              <img className="illustration" src={p3.src} />
            </div>
          </div>
        </div>
        <div className="block3">
          <div className="content">
            <div className="title-w">
              <div className="title">
                <img className="circle-big" src={p18.src} />
                课程内容量身定制，时间安排自由灵活
                <img className="circle-small" src={p19.src} />
              </div>
              <div className="line"></div>
            </div>
            <div className="sub-title">集结电鸭核心师资，打磨教学精益求精</div>
            <div className="text-content-w">
              <div className="text-content">
                <div className="item">
                  <div>01</div>
                  <div>
                    助教每周跟你预约一对一视频上课学习时间，不用担心没时间上课。
                  </div>
                </div>
                <div className="item">
                  <div>02</div>
                  <div className="custom">
                    入学测试，全方位诊断，精准定位你当前的优缺点；根据测评结果以及个人需求量身打造学习方案
                  </div>
                </div>
                <div className="item">
                  <div>03</div>
                  <div>根据时间精力，合理规划学习任务；</div>
                </div>
                <div className="item">
                  <div>04</div>
                  <div>学生、老师、助教三人小群畅所欲言，随时答疑</div>
                </div>
                <div className="item">
                  <div>05</div>
                  <div>每节课复盘，实时调整学习材料、学习方案，目标导向</div>
                </div>
              </div>
              <img className="illustration" src={p4.src} />
            </div>
          </div>
        </div>
        <div className="block4">
          <div className="content">
            <div className="title-w">
              <div className="title">
                <img className="circle-big" src={p20.src} />
                流程细致打磨 科学出分方案
                <img className="circle-small" src={p21.src} />
              </div>
              <div className="line"></div>
              <div className="sub-title">开启学习之旅</div>
            </div>
            <div className="list">
              <div className="item">
                <div className="icon">
                  <img src={p5.src} />
                </div>
                <div className="text">问题诊断</div>
                <div className="text1">科学测试</div>
                <div className="text2">准确定位</div>
              </div>
              <div className="item">
                <div className="icon">
                  <img src={p6.src} />
                </div>
                <div className="text">专属定制</div>
                <div className="text1">时间自由</div>
                <div className="text2">内容量身打造</div>
              </div>
              <div className="item">
                <div className="icon">
                  <img src={p7.src} />
                </div>
                <div className="text">合理规划</div>
                <div className="text1">阶段评估</div>
                <div className="text2">因材施教</div>
              </div>
              <div className="item">
                <div className="icon">
                  <img src={p8.src} />
                </div>
                <div className="text">教师答疑</div>
                <div className="text1">课后反馈</div>
                <div className="text2">实时答疑</div>
              </div>
              <div className="item">
                <div className="icon">
                  <img src={p9.src} />
                </div>
                <div className="text">全程陪学</div>
                <div className="text1">专属学习群</div>
                <div className="text2">长期坚持</div>
              </div>
            </div>
          </div>
        </div>
        <div className="block5">
          <div className="content">
            <div className="title-w">
              <div className="title">
                <img className="circle-big" src={p18.src} />
                敢于承诺保障学习效果
                <img className="circle-small" src={p19.src} />
              </div>
              <div className="line"></div>
            </div>
            <div className="text-content">
              <div>
                根据你的英语基础、学习目标、每周可投入时间科学规划学习方案并制定学习目标。
              </div>
              <div className="single">
                学习期间每日打卡督学，每周作业答疑，日常英语群互动。
              </div>
              <div>
                结课时进行效果测评，我们承诺如果学习效果未如期达标，可免费续期学习。
              </div>
            </div>
            <div className="sub-title">根据欧标来进行水平评测</div>
            <div className="graphic-content-wrapper">
              <div className="column column-0">
                <div className="b1">
                  <div className="text3">参考欧标水平</div>
                  <div className="text4">能力概述</div>
                  <div className="text5">能力描述</div>
                </div>
                <div className="b3">雅思</div>
                <div className="b3">托福</div>
                <div className="b3">BEC</div>
                <div className="b3">托业</div>
                <div className="b6">能力展示</div>
              </div>
              <div className="column column-1">
                <div className="b1">
                  <div className="text1">L1-L2</div>
                  <div className="text2">英语入门</div>
                  <div className="text3">A1</div>
                  <div className="text4">简单互动</div>
                  <div className="text5">
                    对于他人缓慢而清晰的对话，能进行非常简单的对话，并运用基础的语句自我介绍或是陈述自身爱好及兴趣。
                  </div>
                </div>
                <div className="b2">
                  <div>-</div>
                  <div>1-</div>
                </div>
                <div className="b3">-</div>
                <div className="b4">-</div>
                <div className="b5">-</div>
                <div className="b6">用简单英文打招呼，自我介绍</div>
              </div>
              <div className="column column-2">
                <div className="b1">
                  <div className="text1">L3-L4</div>
                  <div className="text2">初级</div>
                  <div className="text3">A2</div>
                  <div className="text4">湿度交流</div>
                  <div className="text5">
                    基本英语应用，能理解日常生活对话。可以和母语人士浅浅交谈，但无法连续对话或用于工作。
                  </div>
                </div>
                <div className="b2">
                  <div>4分</div>
                  <div></div>
                </div>
                <div className="b3">8-12口语单项</div>
                <div className="b4">-</div>
                <div className="b5">120-220</div>
                <div className="b6">介绍工作，自主办理酒店入住</div>
              </div>
              <div className="column column-3">
                <div className="b1">
                  <div className="text1">L5-L6</div>
                  <div className="text2">中级</div>
                  <div className="text3">B1</div>
                  <div className="text4">准确表达</div>
                  <div className="text5">
                    可用于大部分旅游及熟悉话题对话，在工作场合中，可以围绕自己的专长领域进行阅读及邮件书写，但无法流畅为自己的意见或观点做详尽解释。
                  </div>
                </div>

                <div className="b3">4.5-5分</div>
                <div className="b3">42-71</div>
                <div className="b4">初级</div>
                <div className="b5">220-650</div>
                <div className="b6">应对绝大多数国外生活和旅行需求</div>
              </div>
              <div className="column column-4">
                <div className="b1">
                  <div className="text1">L7-L8</div>
                  <div className="text2">中高级</div>
                  <div className="text3">B2</div>
                  <div className="text4">流畅对话</div>
                  <div className="text5">
                    针对于熟悉的主题做有条理的说明，进行较为深度的交流。在无准备的情况下，谈论熟悉的:家庭
                    休闲 工作 旅游 时事等内容。
                  </div>
                </div>

                <div className="b3">5.5-6.5分</div>
                <div className="b3">72-95</div>
                <div className="b4">中级</div>
                <div className="b5">650-990</div>
                <div className="b6">
                  适应全英文生活&办公环境能理解大部分英文报刊
                </div>
              </div>
              <div className="double">
                <div className="top">
                  <div className="column column-5">
                    <div className="b1">
                      <div className="text1">L9-L10</div>
                      <div className="text2">中高级</div>
                      <div className="text3">C1</div>
                      <div className="text4">深度讨论</div>
                      <div className="text5">
                        在社交、学术或专业场合可流畅的和母语人士进行对话，并且可针对广泛主题提出解释与分析，但话题过于冷僻时可能无法流畅表达自己的想法及观点。可在英文环境下工作，并理解复杂文章段落的具体或抽象主旨。
                      </div>
                    </div>
                    <div className="b3">7-8分</div>
                    <div className="b3">95-110</div>
                  </div>
                  <div className="column column-6">
                    <div className="b1">
                      <div className="text1">L11-L12</div>
                      <div className="text2">高级</div>
                      <div className="text3">C2</div>
                      <div className="text4">自如运用</div>
                      <div className="text5">
                        英文能力接近母语程度，能独立而熟练的运用英文准确描述大部分事物。可胜任全英文的工作或者学术环境，对于复杂主题能流畅表达意见，并能组成用字精准的文章。
                      </div>
                    </div>

                    <div className="b3">8.5-9分</div>
                    <div className="b3">110-120</div>
                  </div>
                </div>
                <div className="bottom">
                  <div className="b1">高级</div>
                  <div className="b2">900+</div>
                  <div className="b3">无字幕看美剧，自如参加商务谈判</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="block6">
          <div className="content">
            <div className="title-w">
              <div className="title">
                <img className="circle-big" src={p18.src} />
                丰富的学习服务体系，管家式服务
                <img className="circle-small" src={p19.src} />
              </div>
              <div className="line"></div>
            </div>
            <div className="list">
              <div className="item">
                <img className="img1" src={p11.src} />
                <div>一对一陪学作为主航船，伴有组队式社群让你学习动力充足</div>
              </div>
              <div className="item">
                <img className="img2" src={p12.src} />
                <div>不定期直播、圆桌会议让你学习不再枯燥</div>
              </div>
              <div className="item">
                <img className="img3" src={p13.src} />
                <div>助教全程学习进度监督反馈，助力达成目标。</div>
              </div>
            </div>
          </div>
        </div>
        <div className="block7">
          <div className="content">
            <div className="title-w">
              <div className="title">
                <img className="circle-big" src={p20.src} />
                层层筛选师资力量，教学质量有保障
                <img className="circle-small" src={p21.src} />
              </div>
              <div className="line"></div>
            </div>
            <div className="text-content">
              我们的老师均是拥有雅思8分以上或者托福110以上证书，全部是海外华人且有外企工作经验，而且老师有1年以上英语辅导经验。
            </div>
            <div className="text-content">
              根据过往数据我们只录取参与面试不到1%的优秀老师，保证专业实力过硬，有灵活的教学方法，可以针对不同基础的学员因材施教，教学质量有保证。
            </div>
            <div className="list">
              <div className="item">
                <div className="name">Ruii</div>
                <div className="line"></div>
                <div className="sub-list">
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>5年外企IT高级产品经理</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>旅居世界各地</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>英国信息管理学硕士</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>3年一对一英语教学经验</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>擅长”Natural order of acquisition”教学方法</div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="name">Leila</div>
                <div className="line"></div>
                <div className="sub-list">
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>美国长大，中英双母语</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>正宗美式发音</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>国内985硕士毕业</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>雅思8分</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>多年1v1英语教学经验、雅思口语老师</div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="name">Amber</div>
                <div className="line"></div>
                <div className="sub-list">
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>毕业于香港理工大学，硕士学位</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>15年英语教学经验</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>资深英语老师</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>课堂氛国活泼，帮助学员轻松提升英语能力</div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="name">Fiona</div>
                <div className="line"></div>
                <div className="sub-list">
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>留加硕士</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>
                      拥有TESOL高级英语、商务英语、少儿英语教师资格证、英语专业八级证书
                    </div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>多年一对一、一对多各个年龄阶段英语教学经验</div>
                  </div>
                  <div className="sub-item">
                    <div className="dot"></div>
                    <div>学员来自全球各地</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="block8">
          <div className="content">
            <div className="title-w">
              <div className="title">
                <img className="circle-big" src={p18.src} />
                训练营模式
                <img className="circle-small" src={p19.src} />
              </div>
              <div className="line"></div>
            </div>
            <div className="list">
              <div className="item">
                <div className="title">3月极速提升营</div>
                <div className="b1">
                  <div className="left">目标</div>
                  <div className="right">提升2-3个欧标等级</div>
                </div>
                <div className="b2">
                  <div className="left">适合学员</div>
                  <div className="right">
                    <div>英语6级通过，且不超过3年</div>
                    <div>每周可学习时长不低于20小时</div>
                  </div>
                </div>
                <div className="b3">
                  <div className="left">课程时长</div>
                  <div className="right">3个月</div>
                </div>
                <div className="b4">
                  <div className="left">报名费用</div>
                  <div className="right">6980元</div>
                </div>
              </div>
              <div className="item">
                <div className="title">9月极速提升营</div>
                <div className="b1">
                  <div className="left">目标</div>
                  <div className="right right2">提升至欧标B2</div>
                </div>
                <div className="b2">
                  <div className="left">适合学员</div>
                  <div className="right">
                    <div>英语4级未过或近3年基本没用过英语</div>
                    <div>每周可学习时长不低于10小时</div>
                  </div>
                </div>

                <div className="b3">
                  <div className="left">课程时长</div>
                  <div className="right">9个月</div>
                </div>
                <div className="b4">
                  <div className="left">报名费用</div>
                  <div className="right">13980元</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="block9">
          <div className="content">
            <div className="title-w">
              <div className="title">
                <img className="circle-big" src={p18.src} />
                学员一致好评，有进步有结果，才有好口碑
                <img className="circle-small" src={p19.src} />
              </div>
              <div className="line"></div>
            </div>
            <div className="wechat-pics">
              <img src={p16.src} />
            </div>
          </div>
        </div>
        <div className="block10">
          <div className="title">最后，有疑问或报名参加</div>
          <div className="line"></div>
          <div className="contact-text">请联系训练营负责人</div>
          <img src={p17.src} />
        </div>
      </div>
    </SiteLayout>
  );
};
export default Page;
